import { CollectionType } from '../collection-type';

export class FindCollectionProvidersRequest {
  public collectionType: CollectionType;
  public collectionKey: string;
  public maxRows?: number;
}